import { render } from "./TranslationPanel.vue?vue&type=template&id=567190fa&scoped=true"
import script from "./TranslationPanel.vue?vue&type=script&lang=ts"
export * from "./TranslationPanel.vue?vue&type=script&lang=ts"

import "./TranslationPanel.vue?vue&type=style&index=0&id=567190fa&lang=scss&scoped=true"
import "./TranslationPanel.vue?vue&type=style&index=1&id=567190fa&lang=scss"
script.render = render
script.__scopeId = "data-v-567190fa"

export default script